module.exports = __webpack_public_path__ + "img/user-card-no-bg.5bef124f.png";